export enum AssetType {
  Currency = "currency",
  Custom = "custom",
  Token = "token",
  NFT = "nft",
}

export type AssetData = {
  code: string;
  name: string;
  address?: string;
  tokenId?: string;
  image?: string;
  type: AssetType;
};

export type ExtendedAssetData = AssetData & {
  marketCapRank?: number;
  cryptoCompareId?: string;
};
